export default __webpack_public_path__ + "static/media/95.55485834.jpg";